module.exports = {
          srcSet: __webpack_public_path__ + "public/images/3cfec5a6de6b3f9f85e4ec03773f9c5c-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/3cfec5a6de6b3f9f85e4ec03773f9c5c-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/3cfec5a6de6b3f9f85e4ec03773f9c5c-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/3cfec5a6de6b3f9f85e4ec03773f9c5c-1774.jpg"},
          
          width: 1774,
          height: 887
        }